// extracted by mini-css-extract-plugin
export default {"card":"styles__card--IA+sh","agent-detail":"styles__agent-detail--g8Xvp","detail-text":"styles__detail-text--rog5k"};